import React from 'react';
import Utils from '../../providers/Utils';
import { Grid, Avatar, Divider } from '@material-ui/core';
import Ws from '../../providers/Ws';
import SpecificComponent from '../../commons/SpecificComponent';


export default class ListEtapeAddProiect extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }

    u = new Utils()

    numeAvatar = (nume) => {

        if(nume){
            let n = nume.split(' ')

            // console.log('n :>> ', n);
    
            let firstLetters = ''
    
            if (n[0]) {
    
                firstLetters += n[0].substring(0, 1)
    
            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }
    
            firstLetters = firstLetters.toUpperCase()
    
            return firstLetters
        }else{
            return 'NA'
        }
        

    }
    render() {
        return (

            <Grid container>
                {this.props.etape.map((e, idx) => {
                    return (
                        <Grid style={{ fontSize: 14, textAlign: 'left', marginTop: 20 }} key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container>
                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                            <span>   {this.dictionary.proiecte.etapa} {idx + 1}: </span>
                                        </Grid>
                                        <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                                            <span>{e.denumire}</span>
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <span>   {this.dictionary.proiecte.dateStart}: <i style={{ verticalAlign: 'middle' }} className='material-icons'>event</i> {e.durata_de_la} {e.cand_ora && <i style={{ verticalAlign: 'middle' }} className='material-icons'>schedule</i>}  {this.u.transformTimeFromSql(e.cand_ora)}</span>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                            <i style={{ marginRight: 5, cursor: 'pointer' }} onClick={() => { this.props.updateEtapa(e) }} className='material-icons'>edit</i> <i style={{ cursor: 'pointer' }} onClick={() => { this.props.deleteEtapa(e) }} className='material-icons'>delete</i>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container>
                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>

                                        </Grid>
                                        <Grid style={{ paddingRight: 10 }} item xs={5} sm={5} md={5} lg={5} xl={5}>
                                            <span>{e.note}</span>
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <span>  {this.dictionary.proiecte.dateFinish}: <i style={{ verticalAlign: 'middle', marginLeft: 6 }} className='material-icons'>event</i> {e.durata_pana_la} {e.pana_cand_ora && <i style={{ verticalAlign: 'middle' }} className='material-icons'>schedule</i>}  {this.u.transformTimeFromSql(e.pana_cand_ora) }</span>

                                            <div style={{ padding: '10px 0 10px 0', display: 'flex', justifyContent: 'space-between' }} key={idx}>
                                                <div>
                                                    {
                                                        e.poza &&
                                                        <div
                                                            className='pm-angajati-picture'
                                                            style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + e.poza}')`, width: 30, height: 30 }}>

                                                        </div>
                                                    }
                                                    {!e.poza &&

                                                        <Avatar
                                                            className='pm-angajati-picture'
                                                            style={{ display: 'inline-block', textAlign: 'center', height: 30, width: 30, backgroundColor: new Utils().culoriUtilizatori(e.id) }}>
                                                            {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                                                            <span style={{ marginTop: '25%', display: 'block', fontSize:14 }}>{this.numeAvatar(e.nume)} </span>
                                                        </Avatar>
                                                        // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                    }
                                                    <span className='pm-task-change-user'>{e.nume}</span>
                                                </div>



                                            </div>
                                        </Grid>

                                    </Grid>
                                </Grid>



                            </Grid>
                            <Divider style={{ width: '100%' }} />
                        </Grid>
                    )
                })}
            </Grid>

        );
    }
}